import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import AppLoader from '@projectK/components/AppLoader';
 
const MyScheduleDashboardMain = (props) => {
  const { isMobile } = useMobileSettings();
  const [component, setComponent] = useState(null);
 
  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import('../MobileComponents/MyScheduleDashboardMob');
        setComponent(() => module.default);
      } else {
        const module = await import('../WebComponents/MyScheduleDashboardWeb');
        setComponent(() => module.default);
      }
    };
 
    loadComponent();
  }, [isMobile]);
 
  const LoadedComponent = component;
  return component ? <LoadedComponent {...props} /> : <AppLoader />;
};
 
export default MyScheduleDashboardMain;
 